<template>
  <div v-if="subsection">
    <div v-if="!isEditMode">
      <h5 v-if="subsection.title" v-html="subsection.title"></h5>
    </div>
    <div v-else>
      <h4>Заголовок</h4>
      <b-form-input
        :value="subsection.title"
        placeholder="Введите название"
        @input="$_subsectionMixin_onTitleChange"
      />
      <div class="text-center mx-auto my-3">
        <b-button variant="outline-primary" @click="addVideo">
          <div v-if="!subsection.file">
            <em class="fa fa-plus mr-1"></em> Добавить видео
          </div>
          <div v-else><em class="fas fa-pen mr-1"></em> Изменить видео</div>
        </b-button>
        <b-button
          variant="outline-primary"
          class="ml-3"
          @click="deleteVideo"
          v-if="subsection.file"
        >
          <em class="fa fa-times"></em> Удалить видео
        </b-button>
      </div>
      <v-modal-files-upload wrkspcType="video"></v-modal-files-upload>
    </div>
    <div v-if="subsection.file" class="w-75 m-auto" style="height: 60vh;">
      <iframe
        width="100%"
        :src="'/api/files/' + subsection.file.physicalName"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
        height="100%"
      >
      </iframe>
    </div>
    <div v-if="!isEditMode">
      <div class="mt-3" v-html="editedText"></div>
    </div>
    <div v-else>
      <h4 class="mt-3">Текст</h4>
      <wysiwyg-text-editor dataType="subSectionText" />
    </div>
    <div class="w-75 mx-auto my-4">
      <choice-variant-test-subsection
        :isEditMode="isEditMode"
        @changedSelectedTabs="updateSelected"
      ></choice-variant-test-subsection>
    </div>
    <div v-if="isEditMode">
      <h4>Ответы</h4>
      <div v-if="isInvalidAnswer" class="text-danger mt-2">
        Введите номера ответов через запятую
      </div>
      <div v-if="isUnrealAnswer" class="text-danger mt-2">
        Указан(ы) несуществующий(ие) вариант(ы) ответа
      </div>
      <b-form-input
        id="input-correct-answers"
        :value="subsection.qstruct ? subsection.qstruct.answer : ''"
        placeholder="Введите номера ответов через запятую"
        @input="onAnswersChange"
      />
    </div>
    <div class="text-center my-3" v-if="!isEditMode && !isTestReviewMode">
      <b-button variant="primary" @click="sendAnswers($event)">
        {{ isTriedToAnswer ? "Ответить ещё раз" : "Ответить" }}
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import WysiwygTextEditor from '@/components/content/edit/WysiwygTextEditor.vue'

import ContentMixin from '@/components/helpers/mixins/content-mixin'
import SubsectionMixin from '@/components/helpers/mixins/subsection-mixin'

const ChoiceVariantTestSubsection = () => import('./ChoiceVariantTestSubsection.vue')
const VModalFilesUpload = () => import('@/components/content/edit/modals/ModalFilesUpload.vue')

export default {
  name: 'TextTestSubSection',
  components: {
    ChoiceVariantTestSubsection,
    WysiwygTextEditor,
    VModalFilesUpload
  },
  mixins: [ContentMixin, SubsectionMixin],
  data() {
    return {
      selectedTabs: [],
      isTriedToAnswer: false,
      correctAnswers: '',
      editedText: ''
    }
  },
  computed: {
    ...mapGetters({
      variants: 'education/getVariantsForTest',
      subsection: 'education/getSubsection',
      updater: 'contentManager/getUpdater',
      isTestingMode: 'test/isTestingMode',
      isTestReviewMode: 'educationStudentsManagement/getTestReviewMode',
      test: 'test/getTest',
      progress: 'test/getProgress'
    }),
    isInvalidAnswer() {
      return !(
        this.correctAnswers && this.correctAnswers.match('^(?:\\d+[ ,]*)*$')
      )
    },
    isUnrealAnswer() {
      let isCorrect = true
      if (
        !this.isInvalidAnswer
        && this.subsection
        && this.subsection.qstruct
        && this.subsection.qstruct.answer
      ) {
        const answers = this.subsection.qstruct.answer
          .replace(' ', '')
          .split(',')
        for (const answer of answers) {
          if (
            answer === '0'
            || (Number(answer) !== 0
              && (Number(answer) > this.variants.length || Number(answer) < 1))
          ) {
            isCorrect = false
          }
        }
      }
      return !isCorrect
    }
  },
  mounted() {
    this.subsectionUpdate()
    this.editedText = this.$_contentMixin_editCaptions(this.subsection.text)
  },
  updated() {
    this.editedText = this.$_contentMixin_editCaptions(this.subsection.text)
  },
  props: {
    isEditMode: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    subsection() {
      this.isTriedToAnswer = false
      this.selectedTabs = []
      this.subsectionUpdate()
    },
    isInvalidAnswer(value) {
      this.$nextTick(() => {
        this.setErrorWithChangingTextTestSubsection(
          value || this.isUnrealAnswer,
        )
      })
    },
    isUnrealAnswer(value) {
      this.$nextTick(() => {
        this.setErrorWithChangingTextTestSubsection(
          value || this.isInvalidAnswer,
        )
      })
    }
  },
  methods: {
    subsectionUpdate() {
      this.correctAnswers = this.subsection && this.subsection.qstruct
        ? this.subsection.qstruct.answer
        : ''
    },
    updateSelected(tabs) {
      this.selectedTabs = tabs
    },
    sendAnswers() {
      const answer = []
      this.selectedTabs.forEach((val) => {
        answer.push(val + 1)
      })
      if (!this.isTestingMode) {
        this.sendAnswer({
          courseId: this.$route.params.courseBookId,
          subsectionId: this.$route.params.subsectionId,
          answer,
          type: 'test'
        })
        this.isTriedToAnswer = true
      } else {
        this.$cookies.set(
          `test_${this.$route.params.sectionId}_${
            this.$route.params.subsectionId
          }_text`,
          JSON.stringify(answer),
        )
        const questions = this.$cookies
          .keys()
          .filter((k) => k.includes(`test_${this.test.id}`))
        this.$_subsectionMixin_updateSolved(questions)
      }
    },
    ...mapMutations({
      setErrorWithChangingTextTestSubsection:
        'contentManager/setErrorWithChangingTextTestSubsection',
      addFileToSubsection: 'education/addFileToSubsection',
      setSubsectionAnswer: 'education/setSubsectionAnswer'
    }),
    ...mapActions({
      updateUpdater: 'contentManager/updateUpdater',
      sendAnswer: 'education/sendAnswer'
    }),
    onAnswersChange(event) {
      this.correctAnswers = document.getElementById(
        'input-correct-answers',
      ).value
      this.updateUpdater()
      this.setSubsectionAnswer(event)
    },
    addVideo() {
      this.$bvModal.show('files-upload-modal')
    },
    deleteVideo() {
      this.updateUpdater()
      this.addFileToSubsection(null)
    }
  }
}
</script>

<style scoped></style>
